export function isPWA() {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    ('standalone' in window.navigator && window.navigator['standalone']) ||
    document.referrer.includes('android-app://')
  );
}
